import BaseController       from "controllers/base"
import uuid                 from 'uuid/v4';

import ItemDocumentFormsWidget from 'widgets/item_documents/itemDocumentFormsWidget.js';

class Controller extends BaseController {
  call() {
    bindItemFormWidgets.call(this)
  }
}

let bindItemFormWidgets = function() {
  new ItemDocumentFormsWidget(this.root)
}

export default Controller
